export default {
  'user.login': 'Anmeldung',
  'user.signup': 'Registrierung',
  'user.profile': 'Profil',
  'user.reset_password': 'Reset des Passworts',
  'user.user_management': 'Benutzerverwaltung',
  'user.send_verification_sms': 'Bestätigungscode senden',
  'user.verification_check': 'überprüfen der Bestätigung',
  'user.change_password': 'das Password ändern',
  'user.username_email': 'Benutzername / E-Mail',
  'user.email': 'E-Mail',
  'user.phone': 'Handynummer ohne null',
  'user.password': 'das Password',
  'user.forgetpassword': 'Sie Ihr Passwort vergessen?',
  'user.changepass': 'Ihr Passwort wurde erfolgreich geändert!',
  'user.loginwithgoogle': 'durch Google anmelden',
  'user.createaccount': 'Konto anlegen',
  'user.offerservices': 'Wir bieten alle Reisedienstleistungen an',
  'user.welcome': 'Willkommen bei Tripsi',
  'user.firstname': 'Vorname',
  'user.lastname': 'Nachname',
  'user.agreemessage': 'Ich bin einverstanden mit',
  'user.rotapolicy': 'Ich stimme den Regeln von Tripsi zu',
  'user.rotapolicy_tripord': 'Ich stimme den Regeln von Tripord zu',
  'user.rotacopyright': 'Tripsi Urheberrechte © 2018',
  'user.emptypass': 'Geben Sie bitte altes oder neues Password ein',
  'user.oldpass': 'Altes Password stimmt nicht!',
  'user.employeeadd': 'Mitarbeiter wird erfolgreich hinzugefügt!',
  'user.tryagain': 'Bitte versuche es noch einmal.',
  'user.changepasssuccess': 'Ihr Passwort wurde nicht geändert',
  'user.newpass': 'Geben Sie bitte ein neues Password ein',
  'user.loginerror': 'Benutzername oder Password ist falsch',
  'user.userlock': 'Benutzername ist blockiert',
  'user.changepasserror':
    'Neues Passwort erneut eingeben . Neues Password stimmt nicht!',
  'user.tripsi': 'Tripsi',
  'user.tripord': 'Tripord',
  'user.userpoint': 'Benutzer Punkt',
  'user.duplicatedusername': 'Die E-Mail ist verdoppelt',
  'user.signuperror': 'E-Mail muss eindeutig sein',
  'user.forgetyour': 'Vergessen',
  'user.createyour': 'Erstelle dein',
  'user.account': 'Konto',
  'user.registerwith': 'oder registrieren Sie sich mit',
  'user.acceptrules': 'Bitte akzeptieren Sie die Site-Regeln',
  'user.fillallfield': 'Bitte alle Felder ausfüllen',
  'user.favourites': 'Favoritinnen',
  'user.nograde': 'Keine Note',
  'user.phone': 'Telefonnummer',
  'user.has_account': 'Ich habe ein Tripsi Konto',
  'user.has_account_tripord': 'Ich habe ein Tripord Konto',
  'user.donthaveaccount': 'Sie haben sich noch nicht registriert?',
  'user.signup_free': 'Melde dich kostenlos an',
  'user.pass_recovery': 'Passwort Wiederherstellung',
  'user.remember_password': 'Erinnern Sie sich an Ihr Passwort?',
  'authentication.slugone':
    'Il fornitore più affidabile di servizi turistici in Iran',
  'user.otplogin': 'Anmelden durch Versenden eines Codes per SMS',
  'user.otplogintitle': 'Einmaliges Passwort',
  'user.incorrectcode': 'Der eingegebene Code ist nicht korrekt',
  'user.untilresend': 'Bis zum erneuten Senden',
  'user.phoneoremail': 'E-Mail oder Handy',
  'user.loginwithusername': 'Melden Sie sich mit dem Benutzernamen an',
  'user.sendcode': 'Code Senden',
  'user.sendagain': 'Erneut senden',
  'user.justwelcome': 'Login',
};
